<!-- @format -->

<div id="media-overlay-container">
   <!-- video overlays container -->
   <div id="video-overlay-container"></div>
   <!-- audio tags container -->
   <div id="audio-overlay-container"></div>
</div>
